import { resolveMinMax } from '../../../../../../util/searchParamNameUtils';

export const resolveSearchParameters = ({
  params: {
    id,
    minId,
    maxId,
    minYear,
    maxYear,
    minMonth,
    maxMonth,
    minDay,
    maxDay,
    country,
    location,
    state,
    locInclude,
    locStart,
    locMatch,
    locNot,
    tsunamiEventId,
    assocData,
    minLatitude,
    maxLatitude,
    minLongitude,
    maxLongitude,
  },
}) => {
  const messages = [];

  if (id != null) {
    messages.push(`ID = ${id}`);
  }

  resolveMinMax('ID', minId, maxId, messages);
  resolveMinMax('Year', minYear, maxYear, messages);
  resolveMinMax('Month', minMonth, maxMonth, messages);
  resolveMinMax('Day', minDay, maxDay, messages);

  if (country != null) {
    messages.push(`Country = ${country}`);
  }

  if (location != null) {
    messages.push(`Region = ${location}`);
  }

  if (state != null) {
    messages.push(`State = ${state}`);
  }

  if (locInclude != null) {
    messages.push(`Location contains '${locInclude}'`);
  }

  if (locStart != null) {
    messages.push(`Location starts with '${locStart}'`);
  }

  if (locMatch != null) {
    messages.push(`Location = '${locMatch}'`);
  }

  if (locNot != null) {
    messages.push(`Location != '${locNot}'`);
  }

  if (tsunamiEventId != null) {
    messages.push(`Tsunami Event Id = ${tsunamiEventId}`);
  }

  if (assocData != null) {
    if (assocData === '1') {
      messages.push('Return All Records');
    } else if (assocData === '2') {
      messages.push('Only records with images online');
    } else if (assocData === '3') {
      messages.push('Only records with digital data');
    }
  }
  resolveMinMax('Latitude', minLatitude, maxLatitude, messages);
  resolveMinMax('Longitude', minLongitude, maxLongitude, messages);

  return messages;
};
